import api from '../api';

function authHeaders(accessToken) {
    return {
        Authorization: `Bearer ${accessToken}`,
    };
}

export function integrationApiBase() {
    return String(api.defaults.baseURL || '').replace(/\/$/, '');
}

export default {
    async getKey(accessToken) {
        const response = await api.get('/integration-keys/key', {
            headers: authHeaders(accessToken),
        });
        return response.data;
    },
    async generateKey(accessToken) {
        const response = await api.post('/integration-keys/key', null, {
            headers: authHeaders(accessToken),
        });
        return response.data;
    },
    async revokeKey(accessToken) {
        const response = await api.delete('/integration-keys/key', {
            headers: authHeaders(accessToken),
        });
        return response.data;
    },
    async listRequests(accessToken) {
        const response = await api.get('/integration-keys/requests', {
            headers: authHeaders(accessToken),
        });
        return Array.isArray(response.data) ? response.data : [];
    },
};
